import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Container, Stack, Text, Title, TextInput, PasswordInput, Button, Paper, Anchor } from '@mantine/core'
import { IconMail, IconLock } from '@tabler/icons-react'
import { useAuth } from '../hooks/useAuth'

export default function Login() {
  const navigate = useNavigate()
  const { login } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    await login(email, password)
    setLoading(false)
  }

  const inputStyles = {
    input: {
      background: 'rgba(10, 22, 40, 0.8)',
      border: '1px solid rgba(0, 255, 255, 0.15)',
      color: '#e0e8f0',
    },
    label: { color: 'var(--mantine-color-gray-4)' },
  }

  return (
    <Container size="xs" py="xl">
      <Stack align="center" gap="lg" style={{ minHeight: '50vh', justifyContent: 'center' }}>
        <Title order={2} ff="Orbitron, sans-serif" c="cyan.4">
          Log In
        </Title>

        <Paper p="xl" className="glass" w="100%">
          <form onSubmit={handleSubmit}>
            <Stack gap="md">
              <TextInput
                label="Email"
                placeholder="your@email.com"
                leftSection={<IconMail size={16} />}
                value={email}
                onChange={(e) => setEmail(e.currentTarget.value)}
                type="email"
                required
                styles={inputStyles}
              />

              <PasswordInput
                label="Password"
                placeholder="Your password"
                leftSection={<IconLock size={16} />}
                value={password}
                onChange={(e) => setPassword(e.currentTarget.value)}
                required
                styles={inputStyles}
              />

              <Anchor
                c="cyan.4"
                size="sm"
                onClick={() => navigate('/forgot-password')}
                style={{ alignSelf: 'flex-end', marginTop: -8 }}
              >
                Forgot password?
              </Anchor>

              <Button type="submit" loading={loading} fullWidth size="md">
                Log In
              </Button>
            </Stack>
          </form>
        </Paper>

        <Text size="sm" c="dimmed">
          Don't have an account?{' '}
          <Anchor c="cyan.4" onClick={() => navigate('/signup')}>
            Sign up
          </Anchor>
        </Text>
      </Stack>
    </Container>
  )
}
